<script>
import VClamp from 'vue-clamp';

export default {
  name: 'CpMemberComponent',
  directives: {
    margin: require('../directives/margins').margin,
  },
  components: {
    handleImageError: require('../mixins/utils').default,
    VClamp,
    TruncateText: require('../components/TruncateText').default,
  },
  props: {
    image: { type: String, default: '' },
    fullname: { type: String, default: '' },
    description: { type: String, default: '' },
    permalink: { type: [String, null], default: null },
    maxLines: { type: Number, default: 2 },
    tag: { type: String, default: '' },
  },
  data() {
    return {};
  },
  methods: {
    navigateTo(path) {
      window.location.href = path;
    },
  },
};
</script>
<template>
  <a :href="permalink" target="_blank" rel="noopener noreferrer" :disabled="!permalink" class="memberContainer">
    <span v-if="tag" class="member-tag caption">{{ tag }}</span>
    <div class="memberImage">
      <div class="circle-container">
        <img :src="`${image}`" alt="Member's image" @error="handleImageError" />
      </div>
    </div>
    <span class="textContainer">
      <p class="caption1 neutral-2-color" v-margin="0">{{ fullname }}</p>
      <p v-margin="0">
        <TruncateText :content="description" :lineClamp="maxLines" :withMoreButton="false" textClass="caption neutral-2-color" />
      </p>
    </span>
  </a>
</template>

<style scoped>
.memberContainer {
  display: flex;
  align-items: center;
  padding: 8px 0;
  margin: 4px 0;
  position: relative;
}
.member-tag {
  position: absolute;
  top: 4px;
  right: 8px;
  display: flex;
  background-color: var(--primary-1);
  color: var(--primary);
  border-radius: 4px;
  padding: 2px 4px;
}
.memberImage {
  background: var(--secondary-1);
  margin-right: 10px;
  border-radius: 50%;
}
.circle-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}
.circle-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.textContainer {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}
.textContainer p {
  width: 100%;
  overflow: hidden;
}
</style>
